
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { axiosInstance } from "../axios-instance";

class SubscriptionCatalog {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  postSync(body?: any): Promise<AxiosResponse<any>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<any>(`${this.baseUrl}/syncCatalog`, body, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default SubscriptionCatalog;
